<template>
    <div v-in-viewport="fetchData">
        <graph-title
            :title="title"
            :description="description"
        />
        <div v-if="fetching" class="h-336 w-full flex items-center justify-center">
            <loading color="blue" size="small"></loading>
        </div>
        <div v-else>
            <div v-if="seriesDataLength">
                <div class="h-full relative">
                    <apex-charts
                        :ref="`intake${this.type[0].toUpperCase()}${this.type.slice(1)}`"
                        type="bar"
                        :height="75 + seriesDataLength * 30"
                        width="100%"
                        :options="chartOptions"
                        :series="series"
                    ></apex-charts>
                </div>
            </div>
            <div v-else class="flex flex-col px-10">
                <span class="text-center italic my-16">{{ $t('analytics.empty_series') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import analyticsMixins from "../../mixins/analyticsMixins";
import GraphTitle from "./GraphTitle";
import ApexCharts from "vue-apexcharts";
import chartOptions from '../../config/apex-charts';
import Loading from "../ui/Loading";
import SvgIcon from '../ui/SvgIcon';
import * as analytics from "../../services/AnalyticsService";

export default {
    name: 'Intake',
    components: {
        Loading,
        ApexCharts,
        SvgIcon,
        GraphTitle,
    },
    props: {
        type: {type: String, default: 'best'}, // `best` or `worst`
        filterFields: Object
    },
    mixins: [analyticsMixins],
    data() {
        return {
            chartOptions: {
                ...chartOptions,
                colors: [this.type === 'best' ? '#008FFB' : '#FF4560'],
                fill: {
                    colors: [this.type === 'best' ? '#008FFB' : '#FF4560'],
                },
                yaxis: {
                    ...chartOptions.yaxis,
                    labels: {
                        ...chartOptions.yaxis.labels,
                        offsetY: 2.5,
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        dataLabels: {
                            barHeight: '10%',
                        }
                    },
                }
            },
        }
    },
    computed: {
        title() {
            return this.type === 'best' ? this.$t('analytics.info.intake_vacancy.best.title').toString()
                : this.$t('analytics.info.intake_vacancy.worst.title').toString();
        },
        description() {
            return this.type === 'best' ? this.$t('analytics.info.intake_vacancy.best.description').toString()
                : this.$t('analytics.info.intake_vacancy.worst.description').toString();
        },
    },
    methods: {
        async fetchData(fresh = true) {
            if (!this.sendRequest() && !fresh) {
                this.fetching = false;
                return;
            }
            return await analytics.intake(this.filterFields, this.type).then(response => {
                this.graphData = response;
            }).then(() => {
                this.buildChart();
            })
        },
        buildChart() {
            this.series = this.getPageData()
            this.fetching = false;
            this.$nextTick(() => {
                // intakeWorst / intakeBest
                this.graphRef = this.$refs[`intake${this.type[0].toUpperCase()}${this.type.slice(1)}`];
                this.setDownloadButtonId(this.graphRef
                    , `downloadChartIntake${this.type[0].toUpperCase()}${this.type.slice(1)}`);
            });
        },
    },
}
</script>
